import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import SafetyTips from './components/SafetyTips';
import FAQSection from './components/FAQSection';

export default function Home() {
  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '成人网站完整指南：安全访问与内容筛选',
    description: '提供安全访问建议、隐私保护方法、内容分级筛选及合规使用须知，帮助成年用户理性、安全地了解相关平台信息。',
    url: 'https://safe-guide.example.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '安全指南',
      url: 'https://safe-guide.example.com/',
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageSchema) }}
      />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedArticles />
        <SafetyTips />
        <FAQSection />
      </main>
    </>
  );
}